import React, { Component } from "react";
import PropTypes from "prop-types";

/**
 * @class
 * @classdesc Basic controls for subconfigurations.
 *
 * @param {object} props - Control properties
 * @param {object} props.hcs - HcS instance.
 * @param {object} props.data - Subconfiguration data object
 * @param {object} [props.controls] - Button controls configuration.
 * @param {string|bool} [props.controlAdd=addSubCfgObject] - ECS command being sent when user clicks the "add" button.
 * Set "false" or "null" to hide this button.
 * @param {string|bool} [props.controlCopy=copySubCfgObject] - ECS command being sent when user clicks the "copy" button.
 * Set "false" or "null" to hide this button.
 * @param {string|bool} [props.controlDelete=deleteSubCfgObject] - ECS command being sent when user clicks the "delete" button.
 * Set "false" or "null" to hide this button.
 */
export default class HcsSubconfigControls extends Component {
    constructor(props) {
        super(props);

        this.buttonClick = this.buttonClick.bind(this);
    }

    buttonClick(event, command) {
        this.props.onConfig(command);
    }
    
    showButton(buttonName) {
        const { data } = this.props;

        let cardMin = data.data.CARD_MIN;
        let cardMax = data.data.CARD_MAX;
        let numSubCfgs = data.cfgobjs.length;

        if(this.controlProps[buttonName]) {
            switch(buttonName) {
                case "add":
                    return numSubCfgs < cardMax;

                case "copy":
                    return numSubCfgs < cardMax;

                case "delete":
                    return numSubCfgs > cardMin;
            }
        }

        return false;
    }

    get controlProps() {
        return {
            add: this.props.controlAdd,
            copy: this.props.controlCopy,
            delete: this.props.controlDelete
        };
    }

    render() {
        const { hcs, data } = this.props;

        return (
            <div className={"hcs-subconfig-controls hcs-subconfig-controls_" + data.ident}>
                {this.showButton("delete") ?
                    <button
                        type="button"
                        className="hcs-subconfig-button-delete"
                        title={hcs.t.i18next.exists("GUI:SubconfigButtonDelete") ? hcs.t.gui("SubconfigButtonDelete") : null}
                        onClick={(event) => { this.buttonClick(event, this.controlProps.delete); }}
                    >
                        <div>
                            <svg icon-id="icn-024-1-delete" version="2.0">
                                <use href="#icn-024-1-delete"></use>
                            </svg>
                        </div>
                        <span>{hcs.t.ecs("button_subconfig_delete_" + data.ident)}</span>
                    </button> : null
                }
                { this.showButton("copy") ?
                    <button
                        type="button"
                        className="hcs-subconfig-button-copy"
                        title={hcs.t.i18next.exists("GUI:SubconfigButtonCopy") ? hcs.t.gui("SubconfigButtonCopy") : null}
                        onClick={(event) => { this.buttonClick(event, this.controlProps.copy); }}
                    >
                        <div>
                            <svg icon-id="icn-058-2-duplicate" version="2.0">
                                <use href="#icn-058-2-duplicate"></use>
                            </svg>
                        </div>
                        <span>{hcs.t.ecs("button_subconfig_copy_" + data.ident)}</span>
                    </button> : null
                }
                { this.showButton("add") ?
                    <button
                        type="button"
                        className="hcs-subconfig-button-add"
                        title={hcs.t.i18next.exists("GUI:SubconfigButtonAdd") ? hcs.t.gui("SubconfigButtonAdd") : null}
                        onClick={(event) => { this.buttonClick(event, this.controlProps.add); }}
                    >
                        <div>
                            <svg icon-id="icn-005-2-more-dot" version="2.0">
                                <use href="#icn-005-2-more-dot"></use>
                            </svg>
                        </div>
                        <span>{hcs.t.ecs("button_subconfig_add_" + data.ident)}</span>
                    </button> : null
                }
                { this.props.children }
            </div>);
    }
}

HcsSubconfigControls.propTypes = {
    hcs: PropTypes.object,
    data: PropTypes.object,
    controlAdd: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ]),
    controlCopy: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ]),
    controlDelete: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ]),
    onConfig: PropTypes.func
};

HcsSubconfigControls.defaultProps = {
    controlAdd: "addSubCfgObject",
    controlCopy: "copySubCfgObject",
    controlDelete: "deleteSubCfgObject",
    onConfig: _ => { }
};
